export default __webpack_public_path__ + "static/media/Partner-Bedelsford.467dce62.jpg";